import {
  GET_LIST_HOPDONGCHODUYET,
  GET_LIST_HOPDONGCHODUYET_SUCCESS,
  GET_LIST_HOPDONGCHODUYET_FAILURE,
} from "../../actions/DanhSachHopDongChoDuyet/actionTypes";

const initialState = {
  List: [],
  TongBanGhi: 0,
  TongSoTien: 0,
  getListHopDongChoDuyetLoading: false,
};
const getListHopDongChoDuyet = (state, action) => ({
  ...state,
  getListHopDongChoDuyetLoading: true,
});

const getListHopDongChoDuyetSuccess = (state, action) => {
  // console.log(action);
  return {
    ...state,
    List: action.payload.List,
    TongBanGhi: action.payload.TongBanGhi,
    TongSoTien: action.payload.TongSoTien,
    getListHopDongChoDuyetLoading: false,
  };
};

const getListHopDongChoDuyetFailed = (state, action) => ({
  ...state,
  getListHopDongChoDuyetLoading: false,
  List: [],
});
export const listHopDongChoDuyetReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_HOPDONGCHODUYET:
      return getListHopDongChoDuyet(state, action);
    case GET_LIST_HOPDONGCHODUYET_SUCCESS:
      // alert("tuty");
      return getListHopDongChoDuyetSuccess(state, action);
    case GET_LIST_HOPDONGCHODUYET_FAILURE:
      //alert('false')
      return getListHopDongChoDuyetFailed(state, action);
    default:
      return state;
  }
};

export default listHopDongChoDuyetReducer;
